export default "__VITE_ASSET__4d0c5ebe__"